/* eslint-disable */
const FETCH_PRODUCTS = 'Fetch_PRDUCTS'; // Keep your original name
const UPDATE_PRODUCT = 'UPDATE_PRODUCT'; // Add this new action type
const ADD_PRODUCT = 'ADD_PRODUCT'; 

const initialState = [];

export const fetchProducts = (payload) => ({
  type: FETCH_PRODUCTS,
  payload,
});

export const updateProduct = (payload) => ({
  type: UPDATE_PRODUCT,
  payload,
});

export const addProduct = (payload) => ({
  type: ADD_PRODUCT,
  payload,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCTS:
      return action.payload;
    case UPDATE_PRODUCT:
      // Update a single product without replacing the entire state
      return state.map(product => 
        product.id === action.payload.id ? action.payload : product
      );
    case ADD_PRODUCT:
      return [...state, action.payload];
    default:
      return state;
  }
};

export default reducer;